const dateFormat = 'MM/DD/YYYY';

export default dateFormat;



// WEBPACK FOOTER //
// ./src/config/dateFormat.js